import React from "react";

const Footer = () => {
    return (
        <div>
            <footer className="footer">
                © 2024 <b>MSBAE</b>
            </footer>
        </div>
    );
};

export default Footer;
